import { type ReactNode, isValidElement } from 'react';

/**
 * LLM 이 ```mermaid 래퍼 없이 다이어그램 타입 키워드를 코드펜스 언어로 바로 쓰는 경우가 있어
 * (예: ```gantt, ```sequenceDiagram) 이들도 mermaid 로 인식한다. 정확 매칭이라 일반 코드 샘플
 * (```graphql, ```pie-something) 오탐을 피한다.
 */
const MERMAID_DIAGRAM_KEYWORDS = [
  'mermaid',
  'gantt',
  'sequenceDiagram',
  'flowchart',
  'graph',
  'classDiagram',
  'stateDiagram',
  'stateDiagram-v2',
  'erDiagram',
  'journey',
  'pie',
  'gitGraph',
  'mindmap',
  'timeline',
  'quadrantChart',
  'requirementDiagram',
  'C4Context',
  'sankey-beta',
  'xychart-beta',
  'block-beta',
];

const MERMAID_LANG_RE = new RegExp(
  `(?:^|\\s)language-(?:${MERMAID_DIAGRAM_KEYWORDS.join('|')})(?:\\s|$)`,
  'i',
);

/** `<code>` className 이 mermaid (또는 bare 다이어그램 키워드) 코드펜스인지 판별. */
export function isMermaidLang(className: string | undefined): boolean {
  return MERMAID_LANG_RE.test(className ?? '');
}

const CHART_LANG_RE = /(?:^|\s)language-chart(?:\s|$)/;

/** `<code>` className 이 인라인 차트 코드펜스인지 판별. */
export function isChartLang(className: string | undefined): boolean {
  return CHART_LANG_RE.test(className ?? '');
}

/**
 * `pre` 의 자식 `<code>` 가 인라인 렌더(차트/mermaid) 대상이면 true.
 * 이 경우 pre 래퍼/복사버튼을 건너뛰고 자식(이미 InlineChart/InlineMermaid)을 그대로 노출한다.
 */
export function isInlineRenderCodeChild(children: ReactNode): boolean {
  if (!isValidElement(children)) return false;
  const props = (children as { props?: { className?: string } }).props;
  const cls = props?.className;
  return isChartLang(cls) || isMermaidLang(cls);
}
